import { shopListPlaceHolderData } from '~/utils/placeholderData'

export default (centerRoute) => {
    return useFetchWithTanstackQuery({
        queryKey: ['shopList', centerRoute],
        queryFn: () => $fetch(`/api/center/centers/${centerRoute}/shops`),
        options: {
            placeholderData: shopListPlaceHolderData
        }
    })
}
